import request from '@/service/index'
import {getToken} from '@/utils/util'
/**
 * 用户登录
 * @param username
 * @param password
 */
export const login = ({username, password,aliasName}) => {
  const data = {
    username,
    password,
    aliasName,
  }
  return request({
    url: 'web/login/token',
    data,
    method: 'post'
  })
}

/**
 * 获取验证码
 * @param mobile
 * @param tmplType 模版类型(password 忘记密码)
 */
export const getCode = (mobile, tmplType) => {
    const params = {
        mobile,
        tmplType
    }
    return request({
        url: 'msg/sms/verifyCode',
        params,
        method: 'get'
    })
}

/**
 * 忘记密码
 */
export const forgetPassword = (data) => {
    return request({
        url: 'agent/userAgentAccount/forgetPassword',
        data,
        method: 'post'
    })
}


/**
 * 登出
 */
export const logout = () => {
  return request({
    url: 'web/logout/token',
    data:{token:getToken()},
    method: 'post'
  })
}

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return request({
    url: 'web/current/user',
    method: 'get'
  })
}

export const getUserInfoByPassId = (passId={}) => {
    return request({
        url: '/user/userinfo/'+passId+'/info',
        method: 'get'
    })
}

/**
 * 获取代理商的总收入和总订单
 * countType   统计类型(0 日 1 月 2 年)
 */
export const getAccountCount = (params={}) => {
    return request({
        url: 'agent/agentAccountLog/getAccountCount',
        method: 'get',
        params
    })
}

/**
 * 获取代理商的总收入和总订单
 * countType   统计类型(0 日 1 月 2 年)
 */
export const submitFeedback = (data) => {
    return request({
        url: 'user/userFeedback/add',
        method: 'post',
        data
    })
}

/**
 * 获取微信权限验证参数
 */
export const getWXconfigParams = (params) => {
    return request({
        url: 'user/userinfo/getJsSignatureConfig',
        params,
        method: 'get'
    })
}
export const getUserPassByMobileNo = (params) => {
    return request({
        url: 'user/pass/getUserPassByMobileNo',
        params,
        method: 'get'
    })
}


export const registerByMobile = (data) => {
    return postJson({
        url: 'user/userinfo/registerByMobile',
        data,
        method: 'post',
        headers:{'Content-Type': 'application/json' }
    })
}

export const getUserAccount = (params) => {
    return request({
        url: 'user/userAccount/queryInfo',
        params,
        method: 'get'
    })
}





// WEBPACK FOOTER //
// ./src/api/user.js